





































import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator";
import VueI18n from "vue-i18n";
import { DataOptions, DataTableHeader } from "vuetify";
import { RPA_TEMPLATE, PHASE } from "./index";
@Component({
  components: {},
})
export default class SelectRuleTemplateDialog extends Vue {
  @Prop({ default: false }) value: Boolean;
  @Prop({ default: null }) phase: PHASE;
  PHASE_OTHER = PHASE.PHASE_OTHER;

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }

  onSelectTemplate(rpaTemplate: RPA_TEMPLATE) {
    this.$emit("onSelectTemplate", rpaTemplate);
  }

  get isOtherPhase() {
    return this.phase === PHASE.PHASE_OTHER;
  }

  get headers() {
    return [
      {
        text: this.$t("text.no"),
        value: "no",
      },
      {
        text: this.isOtherPhase
          ? this.$t("text.sinceABool")
          : this.$t("text.since"),
        value: this.isOtherPhase ? "sinceABool" : "since",
        width: this.isOtherPhase ? 220 : 150,
      },
      {
        text: this.$t("text.variable"),
        value: "variable",
      },
      {
        text: this.$t("text.type"),
        value: "type",
      },
      {
        text: this.$t("text.conditionType"),
        value: "conditionType",
        width: 140,
      },
      {
        text: this.$t("text.comparison"),
        value: "comparison",
        width: 150,
      },
      {
        text: this.$t("text.value"),
        value: "value",
        width: 150,
      },
      {
        text: this.$t("text.after"),
        value: "after",
        width: 180,
      },
      {
        text: this.$t("text.package"),
        value: "package",
      },
      {
        text: "",
        value: "action",
      },
    ] as DataTableHeader[];
  }

  get items() {
    return [
      {
        rpaTemplate: RPA_TEMPLATE.TEMPLATE_1,
        no: 1,
        since: this.$t("rpaTemplate.templateOne.since"),
        sinceABool: this.$t("rpaTemplate.templateOne.sinceABool"),
        variable: this.$t("rpaTemplate.templateOne.variable"),
        type: this.$t("rpaTemplate.templateOne.type"),
        conditionType: this.$t("rpaTemplate.templateOne.conditionType"),
        comparison: this.$t("rpaTemplate.templateOne.comparison"),
        value: this.$t("rpaTemplate.templateOne.value"),
        after: this.$t("rpaTemplate.templateOne.after"),
        time: this.$t("rpaTemplate.templateOne.time"),
        package: this.$t("rpaTemplate.templateOne.package"),
      },
      {
        rpaTemplate: RPA_TEMPLATE.TEMPLATE_2,
        no: 2,
        since: this.$t("rpaTemplate.templateTwo.since"),
        sinceABool: this.$t("rpaTemplate.templateTwo.sinceABool"),
        variable: this.$t("rpaTemplate.templateTwo.variable"),
        type: this.$t("rpaTemplate.templateTwo.type"),
        conditionType: this.$t("rpaTemplate.templateTwo.conditionType"),
        comparison: this.$t("rpaTemplate.templateTwo.comparison"),
        value: this.$t("rpaTemplate.templateTwo.value"),
        after: this.$t("rpaTemplate.templateTwo.after"),
        time: this.$t("rpaTemplate.templateTwo.time"),
        package: this.$t("rpaTemplate.templateTwo.package"),
      },
      {
        rpaTemplate: RPA_TEMPLATE.TEMPLATE_3,
        no: 3,
        since: this.$t("rpaTemplate.templateThree.since"),
        sinceABool: this.$t("rpaTemplate.templateThree.sinceABool"),
        variable: this.$t("rpaTemplate.templateThree.variable"),
        type: this.$t("rpaTemplate.templateThree.type"),
        conditionType: this.$t("rpaTemplate.templateThree.conditionType"),
        comparison: this.$t("rpaTemplate.templateThree.comparison"),
        value: this.$t("rpaTemplate.templateThree.value"),
        after: this.$t("rpaTemplate.templateThree.after"),
        time: this.$t("rpaTemplate.templateThree.time"),
        package: this.$t("rpaTemplate.templateThree.package"),
      },
    ];
  }
}
